module.exports = __webpack_public_path__ + "static/media/Roshan.86340a0e.webp";